window.dtSalarySlip = function () {
  const dtSalarySlip = new DataTable('#salary-slip-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#salary-slip-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#salary-slip-datatable', 2); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { data: "index" },
      { data: "period" }
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row) {
      $('td', row).addClass('py-1');
    }
  });

  dtFinalTouch();
}
